// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-badge":"sapcnqr-badge-da75b7","sapcnqr-badge--muted":"sapcnqr-badge--muted-7189a1"};